const STEPS = {
  VIEW: 'VIEW',
  EDIT: 'EDIT',
};

export { STEPS };
